import { createDarkTheme } from '../../utils/createDarkTheme';
import { brandWeb } from '../../global/brandColors';
import type { Theme } from '../../types';

export const webDarkTheme: Theme = createDarkTheme(brandWeb);
